import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { FireAndFlowerCardStackBackgroundViewModel } from './fire-and-flower-card-stack-background-view-model';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-fire-and-flower-card-stack-background',
  templateUrl: './fire-and-flower-card-stack-background.component.html',
  styleUrls: ['./fire-and-flower-card-stack-background.component.scss'],
  providers: [FireAndFlowerCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: FireAndFlowerCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
